import { inMegabytes } from './images';

/**
 * A file's size and type in words, as the Document Library's wireframe
 * writes them: "PDF | 1.8 MB", "846 KB", "51 B".
 *
 * In `lib` rather than the documents section because the shared file control
 * says them too, and a section's words may not be reached from `components`.
 */

const KB = 1024;
const MB = KB * KB;

export function sizeInWords(bytes: number): string {
  if (bytes >= MB) return inMegabytes(bytes);
  if (bytes >= KB) return `${Math.round(bytes / KB)} KB`;
  return `${bytes} B`;
}

const TYPE_WORDS: Record<string, string> = {
  'application/pdf': 'PDF',
  'image/png': 'PNG',
  'image/jpeg': 'JPEG',
};

/** The file type in a word, or the media type itself for one the portal has no word for. */
export function typeWord(contentType: string): string {
  return TYPE_WORDS[contentType] ?? contentType;
}
